var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('container',[_c('div',{staticStyle:{"padding":"10px 10px"},attrs:{"slot":"bottom_box_content"},slot:"bottom_box_content"},[_c(_vm.curBottomComponent,{tag:"component"})],1),_c('div',{attrs:{"slot":"bg_map"},slot:"bg_map"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }